<template lang="">
    <div class="interesting">
    <div class="container">
      <div class="interesting-title">
        <h2>{{titleBlogArticle}}</h2>
        <router-link class="interesting-btn" to="/blog">all articles</router-link>
      </div>
      <div class="interesting-main">
        <swiper
          :slidesPerView="'auto'"
          :space-between = "20"
          :navigation="true"
          :modules="modules"
          class="mySwiper3"
        >
          <swiper-slide class="interesting-swiper" v-for="(blogCart, index) in blogCarts" :key="index">
            <div class="interesting-slide_content" @click="cartClick(blogCart.id)">
              <div class="interesting-slide_img1">
                <img :src="blogCart.image">
              </div>
              <div class="interesting-slide_main">
                <p>10 May, 2020</p>
                <h5>{{blogCart.titleCart}}</h5>
              </div>
            </div>
          </swiper-slide>
          <!-- <swiper-slide class="interesting-swiper">
            <router-link class="interesting-slide" to="/article">
              <div class="interesting-slide_content">
                <div class="interesting-slide_img2"></div>
                <div class="interesting-slide_main">
                  <p>10 May, 2020</p>
                  <h5>How fast can you order a car in Canada?</h5>
                </div>
              </div>
            </router-link>
          </swiper-slide>
          <swiper-slide class="interesting-swiper">
            <router-link class="interesting-slide" to="/article">
              <div class="interesting-slide_content">
                <div class="interesting-slide_img3"></div>
                <div class="interesting-slide_main">
                  <p>10 May, 2020</p>
                  <h5>How to save on buying a car? Why is it better to buy from us</h5>
                </div>
              </div>
            </router-link>
          </swiper-slide> -->
        </swiper>
      </div>
      <router-link class="interesting-btn2" to="/blog">all articles</router-link>
    </div>
  </div>
</template>
<script>

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import "swiper/css/navigation";

//import "./style.css";

import { Navigation } from "swiper";

export default {

  props:{
    titleBlogArticle: String,
  },

    components: {
      Swiper,
      SwiperSlide,
    },
    setup() {
      return {
        modules: [Navigation],
      };
    },

    computed: {
        blogCarts(){
            return this.$store.getters.blogCarts
        },
        visibleList: function(){
          return this.blogCarts.slice(0, 3);
        }
    },

    methods:{
        cartClick(id){
            this.$router.push({name: 'Article', query: {'blog': id}})
        }
    },
    
}
</script>
<style lang="scss">

@import '../assets/scss/breakpoints.scss';


                                            //INTERESTING

.interesting {
  margin-top: 220px;
  @include breakpoints(md){
    margin-top: 160px;
  }
  @include breakpoints(sm){
    margin-top: 80px;
  }
}
.interesting-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2{
    font-family: 'Gilroy700';
    font-size: 45px;
    line-height: 140.5%;
    color: #41456B;
    @include breakpoints(sm){
      font-size: 30px;
    }
  }
}
.interesting-btn, .interesting-btn2 {
  font-family: 'Gilroy700';
  font-size: 16px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #7481FF;
  padding: 16px 23px;
  border: 1px solid #7481FF;
  border-radius: 2px;
  @include breakpoints(sm){
    display: none;
    padding: 10px 15px;
  }
}
.interesting-btn2{
  display: none;
  @include breakpoints(sm){
    display: block;
    margin-bottom: 30px;
  }
}
.interesting-main {
  margin-top: 60px;
  @include breakpoints(sm){
    margin-top: 30px;
  }
}
.mySwiper3 {
  padding: 7px;
  .swiper-button-next{
  background-image: url(../assets/img/home-page/arrow-next2.png);
  background-repeat: no-repeat;
  width: 53px;
  height: 53px;
  background-size: 100% 100%;
  right: 7px;
  display: none;
  @include breakpoints(sm){
    display: block;
    width: 35px;
    height: 35px;
  }

  &::after{
    display: none;
  }
}
  .swiper-button-prev{
    background-image: url(../assets/img/home-page/arrow-prev2.png);
    background-repeat: no-repeat;
    width: 53px;
    height: 53px;
    background-size: 100% 100%;
    left: 7px;
    display: none;
    @include breakpoints(sm){
      display: block;
      width: 35px;
      height: 35px;
    }

    &::after{
      display: none;
    }
  }
}

.interesting-slide_content{
  cursor: pointer;
}

.interesting-slide_img1 {
  img{
    width: 100%;
  }
}
.interesting-slide_main {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 20px 30px 30px 30px;
  height: 130px;
  @include breakpoints(xl){
    height: 155px;
  }
  @include breakpoints(lg){
    height: 180px;
  }
  @include breakpoints(md){
    height: 155px;
    padding: 20px 17px 30px 17px;
  }

  p{
    font-family: 'Gilroy400';
    font-size: 16px;
    line-height: 180%;
    letter-spacing: 0.02em;
    color: #606276;
  }

  h5{
    font-family: 'Gilroy600';
    font-size: 20px;
    line-height: 25px;
    color: #41456B;
  }
}

.interesting-slide_content{
  background: #FFFFFF;
  box-shadow: 0px 20px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin-bottom: 40px;
  @include breakpoints(sm){
    margin-bottom: 30px;
  }
}

.interesting-swiper{
  width: 32.4%;
  @include breakpoints(xxxl){
    width: 32.3%;
  }
  @include breakpoints(xxl){
    width: 32.1%;
  }
  @include breakpoints(xl){
    width: 31.8%;
  }
  @include breakpoints(lg){
    width: 31.3%;
  }
  @include breakpoints(md){
    width: 48.4%;
  }
  @include breakpoints(sm){
    width: 100%;
  }
}

.swiper-wrapper{
  justify-content: space-between;
  @include breakpoints(md){
  }
  @include breakpoints(sm){
   // gap: 10px;
  }
}
    
</style>